"use strict";
/*eslint radix: ["error", "as-needed"]*/
const angular = require("angular");

export class ProjectController {
  project = {
    name: "",
    description: "",
  };
  errors = {
    login: undefined,
  };
  submitted = false;
  constructor(arrow, ProjectAPI, $location, screenSize) {
    "ngInject";
    var that = this;
    this.arrow = arrow;
    /*this.arrow.saveAndGoto =function (num) {
      console.log(that.arrow);
      if(that.arrow.activeDir && num == that.arrow.activeDir+1){
        console.log(that.saveProject);
        that.saveProject();
      }
      else{
        that.arrow.goto(num);
      }

    }*/
    this.ProjectAPI = ProjectAPI;
    var s = $location.search();
    if (s.project && parseInt(s.project)) {
      ProjectAPI.get({ id: parseInt(s.project) }).$promise.then((project) => {
        if (!project) {
          return $location.path("/permission").search({});
        }
        that.project = JSON.parse(JSON.stringify(project));
        return;
      });
    }

    this.isMobile = screenSize.on("xs", function (match) {
      that.isMobile = match;
    });
  }

  saveProject(pageId) {
    let that = this;
    this.submitted = true;
    if (this.form_project.$valid) {
      //Update existed project
      if (this.project.id) {
        return this.ProjectAPI.change({
          id: this.project.id,
          name: this.project.name,
          description: this.project.description,
        })
          .$promise.then((result) => {
            //that.arrow.projectId = result?result.id:null;
            pageId = pageId >= 0 ? pageId : 2; //pageId can be 0 (false)
            that.arrow.goto(pageId, result.id);
            return null;
          })
          .catch((err) => null);
      }
      //Create new project
      else {
        return this.ProjectAPI.save({
          name: this.project.name,
          description: this.project.description,
        })
          .$promise.then((result) => {
            //that.arrow.projectId = result?result.id:null;
            pageId = pageId >= 0 ? pageId : 2;
            that.arrow.goto(pageId, result.id);
            return null;
          })
          .catch((err) => null);
      }
    }
  }

  prev() {
    if (this.form_project.$valid) {
      this.saveProject(0);
    } else {
      this.arrow.goto(0);
    }
  }

  next() {
    this.saveProject();
  }
}

export default angular
  .module("dalApp.permission.project", [])
  .component("project", {
    template: require("./project.html"),
    controller: ProjectController,
  }).name;



// WEBPACK FOOTER //
// ./client/app/permission/project/project.component.js